import Scrollbar from "smooth-scrollbar";
import Popover from "../../boot/js/popover";
import Tooltip from "../../boot/js/tooltip";
import {findAll, mergeDeepObject} from "./util";

const VegasUI = {
	boot: () => {
		// Popovers
		let popoverTriggerList = [].slice.call(findAll('[data-bs-toggle="popover"]'));
		popoverTriggerList.map(function (popoverTriggerEl) {
			return new Popover(popoverTriggerEl, {
				html: true,
				container: 'body',
			})
		});

		// Tooltip
		let tooltipTriggerList = [].slice.call(findAll('[data-bs-toggle="tooltip"]'));
		tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new Tooltip(tooltipTriggerEl, {
				trigger: 'hover'
			})
		})
	},

	fancybox: (target = "[data-fancybox]", params = {}) => {
		params = mergeDeepObject(params, {
			Image: {
				zoom: false,
			},

			on: {
				initCarousel: (e, e2) => {
					let fancyboxContainerClass = e.options?.triggerEl?.dataset?.fancyboxClass || '';

					if (fancyboxContainerClass) {
						e.container.classList.add(fancyboxContainerClass)
					}
				}
			}
		});

		fbx.bind(target, params);
	},

	scrollbar: function ($selectors = [], arg = {}) {
		let scrollbars = [];

		if ($selectors.length) {
			scrollbars = $selectors;
		} else {
			scrollbars = findAll('[data-scrollbar]');
		}

		if (scrollbars.length) {
			for (let bar of scrollbars) {
				let option = mergeDeepObject({
					damping: parseInt(bar.dataset.damping) || .1,
					thumbMinSize: parseInt(bar.dataset.thumbMinSize) || 20,
					renderByPixels: bar.dataset.renderByPixels !== 'false',
					alwaysShowTracks: bar.dataset.alwaysShowTracks || false,
				}, arg);

				Scrollbar.init(bar, option);
			}
		}
	},
}

function onReady() {
	// Boot
	VegasUI.boot();

	// Fancybox
	VegasUI.fancybox();

	// ScrollBar
	VegasUI.scrollbar();
}

document.addEventListener("DOMContentLoaded", onReady);
if (window.Turbo !== 'undefined' && typeof onTurboRender === 'function') {
	onTurboRender(onReady);
}

export default VegasUI;
